import ConfigScreen from "../../../common/components/game-screens/ConfigScreen";
import React, {useState} from "react";
import { useTranslation } from "react-i18next";
import { useParams } from 'react-router-dom';
import {PageContainer} from "../../../common/components/page-container/PageContainer";
import {deleteItem, useItemValue} from "../../../common/firebase/db";
import ConfigInputContainer from "../../../common/components/ConfigInputContainer";
import { DeleteOutlined, LoadingOutlined } from "@ant-design/icons";
import {OnlyStringProps} from "../../../common/types";
import {useDebouncedEffect} from "../../../common/hooks";

const LinesAdminPage = () => {
    const [deleting, setDeleting] = useState<string | null>(null);
    const [lines, setLines] = useState<OnlyStringProps>({});
    let { gameId } = useParams();

    const linesFromDb = useItemValue(`/games/${gameId}`);
    useDebouncedEffect(() => {setLines(linesFromDb);}, [linesFromDb], 1000);

    const {t} = useTranslation();
    const confirmMessage = t('games.lines.linesAdmin.deleteConfirm');
    const deleteLine = (key:string) => () => {
        const confirmed = window.confirm(confirmMessage);

        if (!confirmed) return;

        setDeleting(key);
        deleteItem(`/games/${gameId}/${key}`)
            .then(() => {setDeleting(null);})
            .catch(() => {setDeleting(null);});
    };

    const lineAdmin = (lineKey:string) => <ConfigInputContainer key={lineKey} label={lines[lineKey]}>
        {deleting === lineKey ? <LoadingOutlined/> : <DeleteOutlined onClick={deleteLine(lineKey)}/>}
    </ConfigInputContainer>;

    const linesAdmin = Object.keys(lines).map(lineAdmin);

    return <PageContainer>
        <ConfigScreen
            configTitlePath="games.lines.linesAdmin.title"
            showActionButtons={false}
        >
            {linesAdmin}
        </ConfigScreen>
    </PageContainer>;
};

export default LinesAdminPage;
